module.exports = __webpack_public_path__ + "img/danger.5a87aa6d.png";